import { SquareDashedMousePointer } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { Popover, Text } from "../../DesignSystem";
import { useIsSandboxTeam } from "../../Common/Hooks/useIsSandboxTeam";

const BADGE_CLASS = twMerge(
    "flex cursor-pointer items-center gap-0.5 rounded-lg px-1.5 py-0.75 text-bronze-800",
    // Darker on hover and while the popover is open.
    "bg-bronze-200 hover:bg-bronze-300 data-popup-open:bg-bronze-300",
);

/**
 * Header badge that marks the current team as a sandbox. Clicking opens a
 * popover explaining what the sandbox is and pointing at support for issues.
 * Renders nothing when the team is not a sandbox.
 */
export default function SandboxBadge() {
    const isSandbox = useIsSandboxTeam();

    if (!isSandbox) {
        return null;
    }

    return (
        <Popover
            className="w-85 p-4"
            trigger={
                <button type="button" className={BADGE_CLASS}>
                    <SquareDashedMousePointer className="h-3 w-3 stroke-bronze-600" strokeWidth={3} />
                    <Text variant="smallBody600" className="text-bronze-800">
                        Sandbox
                    </Text>
                </button>
            }
        >
            <div>
                <Text variant="body700" className="text-stone-600">Welcome to the purchaser sandbox!</Text>
                <Text variant="body400" className="text-stone-600 mb-3">
                    Feel free to experiment. All messages are contained within this environment to keep your real data safe.
                </Text>
                <div className="flex items-center justify-between rounded-lg bg-bronze-50 px-3 py-2">
                    <Text variant="body500" className="text-stone-600">
                        Something not working?
                    </Text>
                    <a
                        href="mailto:support@purchaser.ai"
                        className="text-base font-bold text-bronze-600 underline"
                    >
                        Let us know
                    </a>
                </div>
            </div>
        </Popover>
    );
}
